import React, { Component } from "react";
import ReactJson from "react-json-view";
class DetailedEligibilityData extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let { detailedData } = this.props;
    return (
      <div>
        <ReactJson
          src={detailedData}
          theme="monokai"
          name={false}
          collapsed={3}
          displayDataTypes={false}
          displayObjectSize={false}
          quotesOnKeys={false}
          sortKeys={true}
        />
      </div>
    );
  }
}

export default DetailedEligibilityData;
